import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";

import {
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILED,
  VALIDATE_OTP_LOADING,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED,
  VALIDATE_OTP_ARN_LOADING,
  VALIDATE_OTP_ARN_SUCCESS,
  VALIDATE_OTP_ARN_FAILED,
} from "../Constants/userConstants"

export const loginUser = (formData,callback=()=>{}) => async (dispatch) => {
  try {

    dispatch({ type: USER_LOGIN_LOADING });

    const requestData = {
        username: formData.email,
        password: formData.password,
        g_recaptcha_response: formData.captcha,
       
      };
 
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };
   //axios.defaults.baseURL = API_URL;

     const { data : result } = await axios.post(FOLDERPATH + "/GenericApi/login", requestData, {
       headers,
    });

    //  const result = {"status":"Success","code":200,"message":"Logged in successfully","data":{"user":"w9MKS7lrSa8LVFXRcaUt1g==:041Gt7FYv2sSxXBpxqD9Ow=="}};

    //const result = {"status":"Error","code":400,"message":"Invalid username or password."};

    console.log(result);
    if (result.status === "success") {
      
      const { data, token } = result;

      let userData = {
        id: token,
        reference: data.reference_number,
        auth_complete: data.auth_complete,
        send_otp:data.send_otp
        // token: user.TOKEN_HASH,
        // firstName: user.USER_FIRST_NAME,
        // lastName: user.USER_LAST_NAME,
        // role: 2,
        // status: 1,
      };

      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: result,
      });

      //setting the values in local storage
     // localStorage.setItem("userVerificationCandidate", JSON.stringify(userData));
     localStorage.setItem("tempToken", JSON.stringify(userData.id));
     callback();
      
    }else{

      dispatch({
        type: USER_LOGIN_FAILED,
        payload: result
      });

      const msg = result.message;

      toast.dismiss();

      toast.error(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }

  } catch (error) {

    localStorage.removeItem("tokenVerification");
    localStorage.removeItem("userVerificationCandidate");

    // dispatch({
    //   type: USER_LOGIN_FAILED,
    //   payload:
    //     error.response && error.response.data.message
    //       ? error.response.data.message
    //       : error.message,
    // });
  }
};



export const validateOtp = (otp) => async (dispatch) => {
  try {

    dispatch({ type: VALIDATE_OTP_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('tempToken')); 

    const requestData = {
        token: userLocalData,
        mobile_otp: otp,
      };
 
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };
   //axios.defaults.baseURL = API_URL;
     const { data : result } = await axios.post(FOLDERPATH + "/GenericApi/verifyOtp", requestData, {
       headers,
    });


    console.log(result);

    if (result.status === "success") {

      const { data } = result;

      dispatch({
        type: VALIDATE_OTP_SUCCESS,
        payload: data,
      });


      const msg = "Logged in successfully";

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    
      
    }else{

      dispatch({
        type: VALIDATE_OTP_FAILED,
        payload: result
      });

      const msg = result.message;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }

  } catch (error) {

   
    dispatch({
      type: VALIDATE_OTP_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const validateOtpARN = (record) => async (dispatch) => {
  try {

    dispatch({ type: VALIDATE_OTP_ARN_LOADING });

    const requestData = {
        ...record
      };
 
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };
   //axios.defaults.baseURL = API_URL;
     const { data : result } = await axios.post(FOLDERPATH + "/GenericApi/verifyArnUserOTP", requestData, {
       headers,
    });


    console.log(result);

    if (result.status === "success") {

      const { data } = result;

      dispatch({
        type: VALIDATE_OTP_ARN_SUCCESS,
        payload: result,
      });


      const msg = "Logged in successfully";

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    
      
    }else{

      dispatch({
        type: VALIDATE_OTP_ARN_FAILED,
        payload: result
      });

      if(result.message !== "You have entered wrong OTP, Please try again"){
      const msg = result.message;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }

    return result;
  }

  } catch (error) {

   
    dispatch({
      type: VALIDATE_OTP_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
// export const verifyToken = (token) => async (dispatch) => {
//   try {
    
//     //dispatch({ type: USER_VERIFICATION_SUCCESS })

//     const requestData = { TOKEN_HASH: token };

//     const headers = {
//       "Content-Type": "application/json",
//     };
//     axios.defaults.baseURL = API_URL;
//     const { data } = await axios.post(FOLDERPATH + "/api/auth/token_validation", requestData, {
//       headers,
//     });

//     if (data.status === true) {
//       const { data: apiData } = data;

//       let payloadData = {
//         userId: apiData.Claims.USER_ID,
//         expiry: apiData.Claims.exp,
//         status: 1,
//       };

//       dispatch({
//         type: TOKEN_VERIFICATION_SUCCESS,
//         payload: payloadData,
//       });

//       //setting the values in local storage
//     }
//   } catch (error) {
//     console.log(error);
//     dispatch({
//       type: TOKEN_VERIFICATION_FAILED,
//       payload: "Something went wrong",
//     });
//   }
// };